<template>
  <section class="max-w-544 pr-16">
    <h3 class="text-h3 mb-8">Lead an Adventure 🤩</h3>
    <p class="text-body mb-16 md:mb-24">
      Infuse your interests into one-of-a-kind, in-home child care experiences parents can book
    </p>
    <div v-if="renderVideo" class="mb-48" style="padding: 56.25% 0 0 0; position: relative">
      <iframe
        src="https://player.vimeo.com/video/716480166?h=937aa32839&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        :alt="videoDescription"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        title="Sittercity Adventures"
      ></iframe>
    </div>
  </section>
</template>

<script lang="ts">
import { onMounted } from 'vue';

const VIMEO_PLAYER_SCRIPT_SRC = 'https://player.vimeo.com/api/player.js';

function ensureVimeoPlayerScript(): void {
  if (document.querySelector(`script[src="${VIMEO_PLAYER_SCRIPT_SRC}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.src = VIMEO_PLAYER_SCRIPT_SRC;
  script.async = true;
  document.head.appendChild(script);
}

export default {
  name: 'LeadAnAdventure',
  props: {
    renderVideo: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const videoDescription = `Fun, upbeat, instrumental music plays while video clips of different sitters doing fun activities with a school-aged child play. Activities include finger painting on a large canvas, singing karaoke, and cooking food in the kitchen. Text over the clips reads: "Created by sitters, inspired by kids." A smartphone appears displaying the Sittercity Adventures app. Text over the animation reads: "Enjoy learning and teaching through play. Nurture an existing hobby or discover a new one!" An animation shows the different Adventures categories popping out of a box: Arts & Crafts, Food, Education, Performing Arts, STEM, Outdoors, and Sports & Exercise. A split-screen shows a sitter texting with a dad with a child on his lap. Text on the screen depicts the conversation as: Sitter: "Tomorrow's Adventure is going to be a blast!" Parent: "Ben is so excited!" Text with a colorful background reads: "Make the most of in-home child care when you connect through learning and adventure!" Animation of the Sittercity Adventures logo.`;

    onMounted(() => {
      ensureVimeoPlayerScript();
    });

    return {
      videoDescription,
    };
  },
};
</script>
